<template>
    <div class="gradeHome">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: "gradeHome",
    components: {
    },
    data() {
        return {

        }
    },
    methods: {
    },
}

</script>
<style scoped lang="less">
</style>